import { Button } from '@acpaas-ui/react-components';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, useParams } from 'react-router-dom';
import { selectedChange } from '../../../actions/table.actions';
import { MODALS } from '../../../constants/modals.constants';
import { DOSSIER_DETAIL_PATH } from '../../../constants/paths.constants';
import { useModal } from '../../../hooks/useModal.hook';
import DeleteWarningModal from '../../../modals/DeleteWarningModal';
import AddRelatedDossierModal from '../../../modals/dossier/AddRelatedDossierModal';
import { DOSSIERS_RELATED_RESOURCE } from '../../../resources/dossiers.related.resource';
import { tableSelectedSelector } from '../../../selectors/resources.selectors';
import dossiersService from '../../../services/api/dossiers.service';
import StaticTable from '../../core/StaticTable';

const DossierDetailRelated = ({ user, data, permissions, onDossierRefetch }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const addRelatedModal = useModal(MODALS.ADD_RELATED_DOSSIER_MODAL);
  const deleteModal = useModal(MODALS.UNLINK_RELATED_CONFIRM_MODAL);
  const resource = {
    ...DOSSIERS_RELATED_RESOURCE,
    table: { ...DOSSIERS_RELATED_RESOURCE.table, enableSelect: permissions.write }
  };
  const selected = useSelector((state) => tableSelectedSelector(state, { resource }));

  if (!permissions.read) {
    return null;
  }

  const handleUnlink = (onError, onSuccess) => {
    dossiersService.removeRelations(params.id, selected, {
      onError,
      onSuccess: () => {
        dispatch(selectedChange(resource, []));
        onSuccess();
        onDossierRefetch();
      }
    });
  };

  const handleRelatedRowClick = (relatedDossier) => {
    window.open(generatePath(DOSSIER_DETAIL_PATH, { id: relatedDossier?.dossierId }), '_blank');
  };

  return (
    <div>
      <StaticTable
        resource={resource}
        data={data?.relatedFiles ?? []}
        onRowClick={handleRelatedRowClick}
        actions={
          permissions.write && [
            selected.length > 0 && (
              <Button
                key="related-remove"
                size="small"
                type="danger"
                className="u-margin-right-sm"
                iconRight="ai-bin"
                onClick={deleteModal.onOpen}
              >
                Ontkoppelen
              </Button>
            ),
            <Button
              key="related-add"
              size="small"
              className="u-margin-right-sm"
              iconRight="ai-add"
              onClick={addRelatedModal.onOpen}
            >
              Gerelateerd dossier toevoegen
            </Button>
          ]
        }
        responsive
      />
      {addRelatedModal.isOpen && (
        <AddRelatedDossierModal {...addRelatedModal} dossierId={params.id} onUpdated={onDossierRefetch} />
      )}
      {deleteModal.isOpen && (
        <DeleteWarningModal
          {...deleteModal}
          warningText="Ben je zeker dat je deze link wilt verbreken?"
          confirmText="Ontkoppelen"
          onConfirm={handleUnlink}
        />
      )}
    </div>
  );
};

export default DossierDetailRelated;
